import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./z7api";

const qk = (id: string) => ["pp", "z7", id] as const;

export function useZ7Overview(connectionId: string | undefined) {
  return useQuery({
    queryKey: qk(connectionId ?? ""),
    queryFn: () => api.getZ7Overview(connectionId as string),
    enabled: !!connectionId,
    staleTime: 15_000,
  });
}

export function useZ7Mutations(connectionId: string) {
  const qc = useQueryClient();
  const inval = () => {
    qc.invalidateQueries({ queryKey: qk(connectionId) });
    qc.invalidateQueries({ queryKey: ["pp", "z7-generations", connectionId] });
  };
  return {
    refreshRows: useMutation({ mutationFn: () => api.z7RefreshRows(connectionId), onSuccess: inval }),
    refreshDxf: useMutation({ mutationFn: () => api.z7RefreshDxf(connectionId), onSuccess: inval }),
    analyzePt: useMutation({
      mutationFn: (v: { fileId?: string; upload?: File }) => api.z7AnalyzePt(connectionId, v),
    }),
    updateRow: useMutation({
      mutationFn: (v: { rowId: string; body: Record<string, unknown> }) => api.z7UpdateRow(v.rowId, v.body),
      onSuccess: inval,
    }),
    updateQuantities: useMutation({
      mutationFn: (v: { rowId: string; cells: { column: string; value?: string | null; clear?: boolean }[] }) =>
        api.z7UpdateQuantities(v.rowId, v.cells),
      onSuccess: inval,
    }),
    saveRates: useMutation({
      mutationFn: (rates: { code: string; rate: string }[]) => api.z7SaveRates(rates),
      onSuccess: inval,
    }),
    generate: useMutation({
      mutationFn: (v: { format: string; doc_number: string; duplicate_quantities: boolean; row_ids?: string[] }) =>
        api.z7Generate(connectionId, v),
      onSuccess: inval,
    }),
    invalidate: inval,
  };
}

export function useZ7Generations(connectionId: string | undefined) {
  return useQuery({
    queryKey: ["pp", "z7-generations", connectionId ?? ""] as const,
    queryFn: () => api.z7Generations(connectionId as string),
    enabled: !!connectionId,
    staleTime: 15_000,
  });
}
